import React from "react";

function AdminProfile() {
  return (
    <div className="contentAdmin bg-adminbg p-4">
      <div className="bg-white p-6 my-5 rounded-md">
        <div className="text-xl font-medium py-3">User Name :</div>
        <h1 className="border text-2xl text-left font-semibold px-3 py-2 rounded">
          Tanishq Shah
        </h1>

        <div className="flex">
          <div className="mt-3 w-1/2 px-4 py-3">
            <div className="text-xl font-medium">Email :</div>
            <div className="text-lg border px-3 py-2 rounded-md">
              {"abc@gmail.com"}
            </div>
          </div>

          <div className="mt-3 w-1/2 px-4 py-3">
            <div className="text-xl font-medium">Phone No. :</div>
            <div className="border px-3 py-2 font-normal rounded">
              {"02-345-2368"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminProfile;
